import { css } from '@emotion/css';
import DagooCautionSurprised from '@src/assets/dagoo-caution-surprised.svg';
import { Img } from 'react-image';

interface ErrorModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export const ErrorModal = ({ isOpen, onClose }: ErrorModalProps) => {
  if (!isOpen) return null;

  return (
    <div className={ModalOverlayStyle}>
      <div className={ModalContentStyle}>
        <div className={ModalWrapperStyle}>
          <div className={TitleSectionStyle}>
            <div className={DagooImageWrapperStyle}>
              <Img src={DagooCautionSurprised} alt='Dagoo caution' className={DagooImageStyle} />
            </div>
            <p className={TitleStyle}>앗! 잠시 문제가 생겼어요</p>
          </div>
          <div className={BodyTextStyle}>
            <p>콘텐츠를 불러오는 중 문제가 생겼어요.</p>
            <p>같은 문제가 반복된다면 리얼월드에 알려주세요.</p>
          </div>
        </div>
        <button className={ButtonStyle} onClick={onClose}>
          돌아가기
        </button>
      </div>
    </div>
  );
};

const ModalOverlayStyle = css`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 16px;
`;

const ModalContentStyle = css`
  background-color: white;
  border-radius: 24px;
  box-shadow: 0px 0px 24px 0px rgba(0, 0, 0, 0.12);
  width: 100%;
  max-width: 327px;
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 32px 24px 24px 24px;
  align-items: center;
`;

const ModalWrapperStyle = css`
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: center;
  width: 100%;
`;

const TitleSectionStyle = css`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`;

const DagooImageWrapperStyle = css`
  width: 160px;
  height: 140px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const DagooImageStyle = css`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

const TitleStyle = css`
  font-family: 'Pretendard', sans-serif;
  font-size: 20px;
  font-weight: 800;
  line-height: 28px;
  color: #1a1a1a;
  text-align: center;
  margin: 0;
`;

const BodyTextStyle = css`
  font-family: 'Pretendard', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  color: #555;
  text-align: center;
  letter-spacing: -0.1px;
  width: 100%;
`;

const ButtonStyle = css`
  width: 100%;
  height: 48px;
  background-color: #7800ff;
  border: none;
  border-radius: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;

  font-family: 'Pretendard', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 22px;
  color: white;
  text-align: center;

  &:hover {
    opacity: 0.9;
  }

  &:active {
    opacity: 0.8;
  }
`;
